import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const HeaderContainer = styled(Flex)(({ theme }) => ({
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap-reverse',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
  [theme.breakpoints.up('lg')]: {
    flexWrap: 'nowrap',
  },
}));

export const NotificationsProfileContainer = styled(Flex)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  order: 1,
  marginLeft: 'auto',
  flex: '0 0 auto',
  justifyContent: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  [theme.breakpoints.up('lg')]: {
    order: 2,
  },
}));

export const BannerContainer = styled(Flex)(({ theme }) => ({
  maxWidth: '100%',
  order: 0,
  margin: theme.spacing(6, 6),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(6, 0),
  },
  [theme.breakpoints.up('md')]: {
    margin: `${theme.spacing(6)} 15%`,
    marginBottom: theme.spacing(6),
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: 700,
    order: 1,
    margin: theme.spacing(6),
  },
}));
